<template>
	<div class="perks--wrapper compact-padding container">
		<div class="container-grid">
			<div class="perks__slider">
				<div class="gradient-box"></div>
				<img
					src="/static/img/landing_page/mobile/studios_arcade.png"
					srcset="/static/img/landing_page/studios_bis.jpg 1000w"
					class="responsive--img"
				/>
			</div>
			<div class="perks__text">
				<h1 class="heading--lg heading">OUR STUDIOS</h1>
				<p class="paragraph  perks__paragraph">
					Bohemia is a proud Czech company with studios in Brno and in
					or near our beautiful capital city, Prague. People know us
					as a freedom-, nature-, and of course beer-loving nation,
					which you’ll see reflected in our games (well, mainly the
					first two; freedom and nature). Over the years we’ve also
					opened offices in the Netherlands, and Thailand.
				</p>
				<div class="divider--sm"></div>
				<div class="cities-wrapper">
					<ul class="city-list row-span-2">
						<span class="text-bold city">Czech Republic</span>
						<li>Prague</li>
						<li>Mnisek</li>
						<li>Brno</li>
					</ul>
					<ul class="city-list">
						<span class="text-bold city">The Netherlands</span>
						<li>Amsterdam</li>
					</ul>
					<ul class="city-list">
						<span class="text-bold city">Thailand</span>
						<li>Pattaya</li>
						<li>Bangkok</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="isocahedron-wrapper">
			<img
				src="/static/img/landing_page/dodecahedron-cube/Cube-dodecahedron.svg"
				class="isocahedron"
			/>
			<img
				src="/static/img/landing_page/dodecahedron-cube/@2xPolygon%20Copy.svg"
				class="polygon"
			/>
			<img
				src="/static/img/landing_page/dodecahedron-cube/@2xPolygon.svg"
				class="rectangle"
			/>
			<img
				src="/static/img/landing_page/dodecahedron-cube/@2xTriangle.svg"
				class="triangle"
			/>
			<div class="gradient-line line-transform"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "our-offices"
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/main";

.isocahedron-wrapper {
	position: absolute;
	right: -203px;
	bottom: 210px;
	@media (max-width: 1650px) {
		display: none;
	}
	.polygon {
		position: absolute;
		top: -36px;
		right: 165px;
	}
	.rectangle {
		position: absolute;
		top: -6px;
		right: 0px;
		transform: rotateZ(-14deg);
	}
	.triangle {
		position: absolute;
		bottom: -36px;
		right: 140px;
		transform: rotateZ(-14deg);
	}
	.isocahedron {
	}
	.gradient-line {
		position: absolute;
		top: 95px;
		right: -28px;
		width: 166px;
		height: 4px;
		transform: rotateZ(-386deg);
		background-image: -webkit-gradient(
			linear,
			right top,
			left top,
			from(#00ba88),
			to(#00b5f2)
		);
		background-image: linear-gradient(270deg, #00ba88 0%, #00b5f2 100%);
		background-repeat: no-repeat;
		background-size: 100% 15px;
	}
	@-moz-keyframes spin {
		100% {
			-moz-transform: rotate(360deg);
		}
	}
	@-webkit-keyframes spin {
		100% {
			-webkit-transform: rotate(360deg);
		}
	}
	@keyframes spin {
		100% {
			-webkit-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
}

.container-grid {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
}

.perks--wrapper {
	position: relative;
	margin-top: 187px;
	margin-bottom: 5em;
	@media (max-width: $tablet) {
		margin-top: 50px;
		margin-bottom: 50px;
	}
	@media (max-width: $compact) {
		margin-top: 80px;
	}
}

.perks__text {
	position: relative;
	z-index: 2;
	padding: 0;
	@media (min-width: $compact) {
		flex: 1;
		padding-left: 15px;
		padding-top: 0px;
	}
	@media (min-width: $tablet) {
		flex: 1;
		padding-left: 34px;
		padding-top: 94px;
	}
}

.perks__slider {
	z-index: 1;
	position: relative;
	width: 690px;
	max-width: 690px;

	@media (max-width: $compact) {
		width: 100%;
	}

	@media (max-width: $compact) {
		width: 190px;
	}

	@media (max-width: $tablet) {
		width: 400px;
		max-width: 400px;
	}
	@media (max-width: 1200px) {
		width: 500px;
		max-width: 500px;
	}
}

.heading {
	color: $text-strong;
	z-index: 4;
	position: relative;
	margin-bottom: $heading-margin-bottom;

	@media (max-width: $tablet) {
		margin-left: 0;
		margin-bottom: 15px;
		margin-top: 20px;
	}
}

.row-span-2 {
	grid-row: 1 / span 2;
}

.cities-wrapper {
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr 1fr;

	@media (max-width: $compact--sm) {
		grid-template-columns: 1fr;
	}
}

.city-list {
	padding-left: 1rem;
	margin: 0;
	margin-bottom: 23px;
	li {
		padding-bottom: 0.5em;
		margin-top: 1em;

		list-style: none;
	}

	li::before {
		content: "";
		background: $mountain-meadow;

		display: inline-block;
		width: 10px;
		height: 10px;
		margin-right: 13px;
		margin-left: 0;
	}
}

.city {
	padding-bottom: 2em;
}

.country-name {
	content: " ";
	display: none;
}

.gradient-box {
	background-image: linear-gradient(to top, #00ba88 0%, #00b5f2 100%);
	width: 329px;
	height: 650px;
	position: absolute;
	z-index: -2;
	opacity: 0.9;
	bottom: 0;
	left: -58px;
	top: -58px;
	@media (max-width: 1200px) {
		width: 185px;
		height: 515px;
		left: -55px;
		top: -28px;
	}
	@media (max-width: $tablet) {
		width: 185px;
		height: 515px;
		left: -55px;
		top: -28px;
	}
	@media (max-width: $compact) {
		width: 40%;
		height: 90%;
		left: -20px;
		top: -25px;
	}
}

.divider--sm {
	padding-top: 35px;
}

.responsive--img {
	width: 100%;
	max-width: 100%;
	height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/landingPageComponents/OurOffices.vue